'use strict';

common.View.create('website::layouts.main.Slider', {

    onDOMLoad() {
        this.initSlider();
    },

    initSlider() {
        let slider = $(".owl-carousel");
        let sliderHeight = slider.data('height');

        slider.owlCarousel({
            items: 1,
            loop: slider.children().length > 1,
            autoplay: slider.children().length > 1,
            autoplayTimeout: 7500,
            autoplayHoverPause: true,
            autoplaySpeed: 1000,
        });

        slider.find('.owl-stage-outer').css('height', sliderHeight);
    },
});
